import dynamic from "next/dynamic";
import Head from "next/head";
import Image from "next/image";
import logo from "@/assets/logo.png";
// Scalar's stylesheet is loaded via <Head> below (public/scalar-api-reference.css,
// copied from @scalar/api-reference-react/dist/style.css) instead of a global
// import: global CSS imports persist after client-side navigation away from
// /docs and bled Scalar's resets into the rest of the site. next/head removes
// the tag on route change, keeping the styles scoped to this page.

const ApiReference = dynamic(
  () =>
    import("@scalar/api-reference-react").then((mod) => mod.ApiReferenceReact),
  { ssr: false },
);

export default function DevelopersPage() {
  return (
    <>
      <Head>
        <title>Jammable API — Developer Documentation</title>
        <meta
          name="description"
          content="Create AI voice covers programmatically with the Jammable API. Search voice models, create covers, and retrieve results."
        />
        <link rel="stylesheet" href="/scalar-api-reference.css" />
      </Head>
      <style jsx global>{`
        body {
          background: #1b1b2f !important;
          overflow: hidden !important;
        }
        .blur,
        div.tw-fixed.tw-bg-white {
          display: none !important;
        }
      `}</style>
      {/* Logo bar - fixed at top */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: 48,
          display: "flex",
          alignItems: "center",
          padding: "0 16px",
          borderBottom: "1px solid #ffffff10",
          background: "#1b1b2f",
          zIndex: 100,
        }}
      >
        <a
          href="/"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            textDecoration: "none",
          }}
        >
          <Image src={logo} alt="Jammable" width={28} height={28} />
          <span style={{ color: "#ffffffcc", fontSize: 14, fontWeight: 600 }}>
            Jammable
          </span>
          <span style={{ color: "#ffffff44", fontSize: 14 }}>/</span>
          <span style={{ color: "#ffffff88", fontSize: 14 }}>API Docs</span>
        </a>
        <a
          href="/developers/dashboard"
          style={{
            marginLeft: "auto",
            color: "#ffffffaa",
            fontSize: 14,
            fontWeight: 600,
            textDecoration: "none",
          }}
        >
          Dashboard &rarr;
        </a>
      </div>
      {/* Scalar - fixed below logo bar, scrolls internally */}
      <ApiReference
        configuration={{
          url: "/openapi.json",
          theme: "kepler",
          hideDarkModeToggle: true,
          hideClientButton: true,
          metaData: {
            title: "Jammable API",
          },
          customCss: `
            .scalar-api-reference__powered-by { display: none !important; }

            .scalar-api-reference {
              position: fixed !important;
              top: 48px !important;
              left: 0 !important;
              right: 0 !important;
              bottom: 0 !important;
              overflow: auto !important;
            }

            .scalar-api-reference aside {
              position: sticky !important;
              top: 0 !important;
              max-height: calc(100vh - 48px) !important;
              overflow-y: auto !important;
            }
          `,
        }}
      />
    </>
  );
}
